import { matchPath } from "react-router";

// The catalog route pattern, intentionally kept as a stable string independent of
// the live <Route> definition: it is the Sentry grouping/label key, so a future
// route restructure should not silently re-bucket the issue and lose its history.
export const CATALOG_ROUTE_PATTERN =
  "/offerings/catalog/:partnerSlug/:catalogSlug?";

/**
 * Sentry tags for an event that happened on the partner catalog route, or undefined
 * when the path is not a catalog route. Lets catalog errors — render-phase or async
 * (which React error boundaries never see) — carry the same partner_slug/route
 * context as blank renders, so the alert identifies the partner.
 */
export function catalogRouteTags(
  pathname: string
): { partner_slug: string; route: string } | undefined {
  const match = matchPath<{ partnerSlug: string }>(pathname, {
    path: CATALOG_ROUTE_PATTERN,
  });
  if (!match) {
    return undefined;
  }
  return {
    partner_slug: match.params.partnerSlug,
    route: CATALOG_ROUTE_PATTERN,
  };
}
